/**
 * Extracts the PID from a URL
 * @param {string} url - The URL from which the PID is extracted.
 * @returns {string}   - The PID extracted from the URL.
 * @example
 * urlToPID('www.example.com/en-US/p/123456'); // 123456
 * if the url is invalid, then -1 is returned see below an example
 * urlToPID('www.example.com/en-US/p/'); // -1
 */
export const urlToPID = (url) => {
  const pattern = /\/(\d+)$/; // Match digits at the end of the URL
  const match = url.match(pattern);
  const extractedNumber = match ? match[1] : '-1'; // Return the match or -1 if not found
  return extractedNumber;
};

export default urlToPID;
